import { FC } from 'react'
import { KTIcon } from '../../../_metronic/helpers'

interface NoDataFoundProps {
  message?: string
  icon?: string
  colSpan?: number
  variant?: 'row' | 'block'
}

const NoDataFound: FC<NoDataFoundProps> = ({
  message = 'No data found',
  icon = 'document',
  colSpan,
  variant = 'block',
}) => {
  const content = (
    <div className='d-flex flex-column align-items-center justify-content-center py-10 text-center'>
      <div
        className='d-flex align-items-center justify-content-center mb-4 rounded-circle'
        style={{ width: 56, height: 56, background: '#F3F4F6' }}
      >
        <KTIcon iconName={icon} className='fs-2x text-muted' />
      </div>
      <p className='text-muted fs-6 fw-semibold mb-0'>{message}</p>
    </div>
  )

  if (variant === 'row' && colSpan) {
    return (
      <tr>
        <td colSpan={colSpan}>{content}</td>
      </tr>
    )
  }

  return content
}

export { NoDataFound }
